<template>
  <v-radio>
    <template v-if="$slots.label" #label>
      <slot name="label" />
    </template>
  </v-radio>
</template>